export default __webpack_public_path__ + "static/media/(27).0c3d8385.jpg";